import React from 'react';

interface RoomStatusJumbotronProps {
    housekeepingUrl: string;
}

const RoomStatusJumbotron: React.FC<RoomStatusJumbotronProps> = ({
    housekeepingUrl,
}) => {
    return (
        <div className="p-4 mb-4 rounded shadow-sm" style={{ backgroundColor: '#f1f3f5' }}>
            <h5 className="mb-3">Room Status Settings</h5>

            <p className="mb-0">
                - Direct link for housekeeping:{" "}
                <a href={housekeepingUrl} target="_blank" rel="noopener noreferrer">
                    {housekeepingUrl}
                </a>
            </p>
        </div>
    );
};

export default RoomStatusJumbotron;
